import { INDEXES_GET_REQUEST, INDEXES_GET_SUCCESS, INDEXES_GET_FAILURE } from "../actions";

export default function indexes(state = { loading: true, data: [] }, action) {
  switch (action.type) {
    case INDEXES_GET_REQUEST:
      return { loading: true, data: [] };
    case INDEXES_GET_SUCCESS:
      return { loading: false, data: action.data };
    case INDEXES_GET_FAILURE:
      return { loading: false, error: action.error };
    default:
      return state;
  }
}
